import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indexValue'
})
export class IndexValuePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): number {
    const numberValue = Number(value);
    if (numberValue > 0) {
      return Math.trunc(numberValue * 100) / 100;
    }

    return numberValue ?? 0;
  }
}
